/**
 * Feedback Services Module
 * Exports all feedback management services and factory functions
 */
// Service exports (one per controller)
export * from './FeedbackService';
export * from './FeedbackCategoryService';
export * from './FeedbackTypeService';
export * from './FeedbackCategoryRecipientService';
export * from './FeedbackNotificationQueueService';
// Service imports for factory
import { FeedbackService } from './FeedbackService';
import { FeedbackCategoryService } from './FeedbackCategoryService';
import { FeedbackTypeService } from './FeedbackTypeService';
import { FeedbackCategoryRecipientService } from './FeedbackCategoryRecipientService';
import { FeedbackNotificationQueueService } from './FeedbackNotificationQueueService';
/**
 * Create all feedback services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all feedback service instances
 */
export function createFeedbackServices(http, config) {
    return {
        feedback: new FeedbackService(http, config),
        feedbackCategory: new FeedbackCategoryService(http, config),
        feedbackType: new FeedbackTypeService(http, config),
        feedbackCategoryRecipient: new FeedbackCategoryRecipientService(http, config),
        feedbackNotificationQueue: new FeedbackNotificationQueueService(http, config),
    };
}
//# sourceMappingURL=index.js.map